import type { ExploreContentItemAuth } from './exploreContentItemAuth';
import type { ExploreContentItemBasicInfo } from './exploreContentItemBasicInfo';
import type { ExploreContentItemContent } from './exploreContentItemContent';

export interface ExploreContentItem {
  /** 인증 컨텍스트 정보 */
  auth?: ExploreContentItemAuth;
  basicInfo?: ExploreContentItemBasicInfo;
  /** 콘텐츠 데이터 (타입에 따라 다른 형식) */
  content?: ExploreContentItemContent;
}
